import { holidays } from "../data/holidaysList";

export const isMarketActiveNow = () => {
  const date = new Date();
  const day = date.getDay();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const isWeekDay = day !== 0 && day !== 6;
  const isHoliday = holidays.some((holiday) =>
    compareDate(new Date(holiday), date)
  );
  const isMarketHour = hours > 9 && hours < 15;
  if (isWeekDay) {
    if (!isHoliday) {
      if (hours === 9 && minutes > 14) {
        return true;
      } else if (hours === 15 && minutes < 30) {
        return true;
      }

      return isMarketHour;
    }
  }
  return false;
};

export const storeData = (key: string, value: any) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const isValidExpiry = (expiry: string) => {
  const date = new Date(expiry);
  date.setHours(15, 30, 0, 0);
  const today = new Date();
  return today.getTime() <= date.getTime();
}

export const checkValidDate = (date: Date) => {
  const oneDay = 24 * 60 * 60 * 1000;
  return new Date().getTime() - date.getTime() < oneDay;
};

export const getData = (key: string) => {
  return JSON.parse(localStorage.getItem(key) || "{}");
};

const compareDate = (from: Date, to: Date) => {
  return (
    from.getDay() === to.getDay() &&
    from.getMonth() === to.getMonth() &&
    from.getFullYear() === to.getFullYear()
  );
};

export const clearApiTimeout = (key: string) => {
  if ((window as any)[key]) clearTimeout((window as any)[key]);
};
